var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"mr-4",class:!_vm.$vuetify.breakpoint.mdAndUp && 'text-xs'},[_c('span',{class:_vm.is_corporate_master && 'warning--text font-weight-bold'},[_vm._v(" PANEL ID: "+_vm._s(_vm.unique_id)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }